import * as types from '../../actions/actiontypes';

import initialState from '../initialstate';

export default function clientRequestRemoveCustomFilterReducer(
	state = initialState.clientRequestRemoveCustomFilterReducer,
	action
) {
	switch (action.type) {
		case types.REMOVE_CUSTOM_FILTER:
			return action.data;

		default:
			return state;
	}
}
